<ng-template #contactItemTemplate let-model="item" let-index="index" let-query="query">
    <span [ngClass]="{ 'overridden': !isTopLevelCompany && (entityType === ReturnSettingsEntityTypeEnum.Return || model.model.contactID !== parentContact?.contactID) }">{{ model.displayName }} </span>
</ng-template>

@if (viewMode === ViewModelEnum.ReturnValues) {
    <div>
        <span [ngClass]="{ 'overridden': contactHasOverride }">{{ contactDisplay }}</span><span [ngClass]="{ 'overridden': representationHasOverride }">{{ representationDisplay }}</span>
    </div>
}
@if (viewMode === ViewModelEnum.Settings) {
    <div class="d-flex">
        <input
            name="contact"
            type="text"
            placeholder="Filter contacts..."
            class="form-control"
            autocomplete="off"
            [ngClass]="{ 'overridden': contactHasOverride }"
            [(ngModel)]="contactFilter"
            container="body"
            [wsTypeahead]="contacts$"
            [typeaheadWaitMs]="750"
            typeaheadOptionField="displayName"
            [typeaheadMinLength]="0"
            [typeaheadScrollable]="true"
            [typeaheadOptionsLimit]="50"
            (blur)="onContactBlur()"
            (typeaheadOnSelect)="onContactSelected($event)"
            [disabled]="isReadonly"
            [typeaheadItemTemplate]="contactItemTemplate"/>
        <select
            name="preparerRepresentation"
            class="form-select form-select-sm"
            [ngClass]="{ 'overridden': representationHasOverride }"
            [(ngModel)]="representationId"
            [disabled]="isReadonly">
            @for (rt of representationTypes; track rt) {
                <option [ngValue]="rt.value"
                        [ngStyle]="{ 'color': !isTopLevelCompany && (entityType === ReturnSettingsEntityTypeEnum.Return || rt.value !== parentRepresentationId) ? 'red' : 'black'}">
                    {{ rt.name }}
                </option>
            }
        </select>
    </div>
}
